module.exports = "/static/video/iceland.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/iceland.mp4
// module id = 391
// module chunks = 0